import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { jwtInterceptor } from '@shared/interceptors/jwt.interceptor';
import { loadingHandlerInterceptor } from '@shared/interceptors/loading-handler.interceptor';
import { errorHandlerInterceptor } from '@shared/interceptors/error-handler.interceptor';
import { recaptchaInterceptor } from '@shared/interceptors/recaptcha.interceptor';
import { OlvaPreset } from '@/theme';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { GlobalDynamicDialogConfig } from '@shared/config/global-dynamic-dialog.config';

export const appConfig: ApplicationConfig = {
    providers: [
        provideHttpClient(withInterceptors([loadingHandlerInterceptor, recaptchaInterceptor, jwtInterceptor, errorHandlerInterceptor])),

        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideAnimationsAsync(),
        provideRouter(routes),
        providePrimeNG({
            theme: {
                preset: OlvaPreset,
                options: {
                    prefix: 'p',
                    darkModeSelector: false, // Desactivar completamente
                    cssLayer: false
                }
            }
        }),

        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: '/i18n/',
                suffix: '.json'
            }),
            fallbackLang: 'en',
            lang: 'es'
        }),
        { provide: DynamicDialogConfig, useClass: GlobalDynamicDialogConfig }
    ]
};
